import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "var(--pl-icon-project-weak)",
      d: "M15.09 2.319a4.76 4.76 0 0 0-6.179 0 2.76 2.76 0 0 1-1.572.65A4.76 4.76 0 0 0 2.97 7.34 2.76 2.76 0 0 1 2.32 8.91a4.76 4.76 0 0 0 0 6.178c.377.443.605.993.651 1.572A4.76 4.76 0 0 0 7.34 21.03c.58.046 1.13.274 1.572.651a4.76 4.76 0 0 0 6.178 0 2.76 2.76 0 0 1 1.572-.651 4.76 4.76 0 0 0 4.37-4.369c.046-.58.273-1.13.65-1.572a4.76 4.76 0 0 0 0-6.178 2.76 2.76 0 0 1-.65-1.572 4.76 4.76 0 0 0-4.37-4.37 2.76 2.76 0 0 1-1.572-.65"
    }, null, -1),
    _createElementVNode("path", {
      fill: "var(--pl-icon-primary)",
      d: "M15.707 8.293a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414-1.414l6-6a1 1 0 0 1 1.414 0M9 8.002c.55 0 .998.447.998.998v1a.998.998 0 1 1-1.996 0V9c0-.551.447-.998.998-.998M15.998 14a.998.998 0 0 0-1.996 0v1a.998.998 0 0 0 1.996 0z"
    }, null, -1)
  ])))
}
export default { render: render }